import { render, staticRenderFns } from "./EnergyValue.vue?vue&type=template&id=636eb029&lang=pug&"
import script from "./EnergyValue.vue?vue&type=script&lang=ts&"
export * from "./EnergyValue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports